import React from "react"

export default function Container({children}){
  return (
    <div className="
      bg-gradient-to-r from-[#060e3d] to-[#132033] 
      pt-2
      z-0
      h-full">
      
     		 {children}

	      </div>
  )
}
